import { render, staticRenderFns } from "./BusinessDocumentList.vue?vue&type=template&id=ec8d387a&"
import script from "./BusinessDocumentList.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec8d387a')) {
      api.createRecord('ec8d387a', component.options)
    } else {
      api.reload('ec8d387a', component.options)
    }
    module.hot.accept("./BusinessDocumentList.vue?vue&type=template&id=ec8d387a&", function () {
      api.rerender('ec8d387a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentList.vue"
export default component.exports